import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    key: String,
  };

  connect() {
    if (this.keyValue && this.getCookie(this.keyValue) === "dismissed") {
      this.element.style.display = "none";
    }
  }

  dismiss() {
    if (this.keyValue) {
      this.setCookie(this.keyValue, "dismissed", 365);
    }
    window.$(this.element).transition("fade");
  }

  setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=/; SameSite=Lax`;
  }

  getCookie(name) {
    return document.cookie.split("; ").reduce((r, v) => {
      const parts = v.split("=");
      return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, "");
  }
}
